import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { Context } from '@grandvisionhq/carts-v2';
import { Button } from '@grandvisionhq/common';
import { Divider } from '@grandvisionhq/elements';
import { Form, FormGroup } from '@grandvisionhq/forms';
import { ProfileSelectors } from '@grandvisionhq/my-account';
import { createSlotsContext } from '@grandvisionhq/slots';
import { useDispatch, useSelector, useIntl } from '@grandvisionhq/state';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { isPrefillFinished, getShippingDetails } from '../../StepShipping/selectors.js';

const [FormSlotsProvider, useBaseFormSlot] = createSlotsContext({
    displayName: 'FormSlotsContext'
});
// @TODO For all forms other than this, don't wait for the prefill to finish,
// can be removed when we move to the new prefill for Express Checkout
const prefillForms = [
    'billingAddress',
    'contactDetails',
    'invoice'
];
const useFormSlot = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const dispatch = useDispatch();
    const { Slots  } = useBaseFormSlot();
    const isPrefillFinished$1 = useSelector(isPrefillFinished);
    const shippingData = useSelector(getShippingDetails);
    const cartContext = React.useContext(Context.CartContext);
    // @TODO move this from here into the prefill mappers
    const profileDateOfBirthValue = (ref = useSelector(ProfileSelectors.getFormData)) === null || ref === void 0 ? void 0 : (ref1 = ref.personalDetails) === null || ref1 === void 0 ? void 0 : ref1.dateOfBirth;
    const cartContainsContactLenses = cartContext === null || cartContext === void 0 ? void 0 : (ref2 = cartContext.cart) === null || ref2 === void 0 ? void 0 : ref2.contains.contactLenses;
    const cartContainsSolutions = cartContext === null || cartContext === void 0 ? void 0 : (ref3 = cartContext.cart) === null || ref3 === void 0 ? void 0 : ref3.contains.solutions;
    const cartContainsPrescriptionGlasses = cartContext === null || cartContext === void 0 ? void 0 : (ref4 = cartContext.cart) === null || ref4 === void 0 ? void 0 : ref4.contains.prescriptionGlasses;
    const cartContainsSunglasses = cartContext === null || cartContext === void 0 ? void 0 : (ref5 = cartContext.cart) === null || ref5 === void 0 ? void 0 : ref5.contains.sunglasses;
    const cartContainsSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref6 = cartContext.cart) === null || ref6 === void 0 ? void 0 : ref6.contains.subscription;
    const cartContainsContactLensesSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref7 = cartContext.cart) === null || ref7 === void 0 ? void 0 : ref7.contains.contactLensesSubscription;
    const handleChange = React.useCallback((formData)=>{
        (props === null || props === void 0 ? void 0 : props.onChange) ? props === null || props === void 0 ? void 0 : props.onChange(formData) : dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch,
        props
    ]);
    /**
   *  Iterate over all form components passed by opco
   *  Bind data to form component
   **/ const forms = Object.entries(Slots).reduce((formItem, [key, Slot])=>{
        let formData = shippingData && shippingData[key] ? shippingData[key].formData : undefined;
        // @TODO move this into the prefill mappers and remove the prefillForms
        // array so we are using the new prefill for Express Checkout
        const expressCheckoutDOBKey = 'express-checkout-dob';
        const dobFormData = formData === null || formData === void 0 ? void 0 : formData[expressCheckoutDOBKey];
        if (dobFormData && profileDateOfBirthValue) {
            formData = swcHelpers.objectSpread({}, formData, {
                [expressCheckoutDOBKey]: swcHelpers.objectSpread({}, dobFormData, {
                    value: dobFormData.value || profileDateOfBirthValue
                })
            });
        }
        if (prefillForms.includes(key) && (!formData || !isPrefillFinished$1)) {
            // If we want to prefill the form, render null until the prefill saga has finished seeding the data
            formItem[key] = null;
        } else {
            // If we render the form with empty formData, the input fields auto register with their empty initialState
            formItem[key] = /*#__PURE__*/ React.createElement(Form, {
                name: key,
                "data-t": key,
                initialFormState: formData,
                onChange: handleChange
            }, /*#__PURE__*/ React.createElement(Slot, {
                cartContainsContactLenses: cartContainsContactLenses,
                cartContainsSolutions: cartContainsSolutions,
                cartContainsSunglasses: cartContainsSunglasses,
                cartContainsSubscription: cartContainsSubscription,
                cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
                cartContainsContactLensesSubscription: cartContainsContactLensesSubscription,
                omitFields: props === null || props === void 0 ? void 0 : props.omitFields
            }));
        }
        return formItem;
    }, {});
    // Warning, these form objects are not memoized. When added to a dependency array, they will trigger rerender loops
    return forms;
};
const useFormSlotWithoutRedux = (props)=>{
    var ref, ref8, ref9, ref10, ref11, ref12;
    const { Slots  } = useBaseFormSlot();
    const cartContext = React.useContext(Context.CartContext);
    const { getLabel  } = useIntl();
    const cartContainsContactLenses = cartContext === null || cartContext === void 0 ? void 0 : (ref = cartContext.cart) === null || ref === void 0 ? void 0 : ref.contains.contactLenses;
    const cartContainsSolutions = cartContext === null || cartContext === void 0 ? void 0 : (ref8 = cartContext.cart) === null || ref8 === void 0 ? void 0 : ref8.contains.solutions;
    const cartContainsPrescriptionGlasses = cartContext === null || cartContext === void 0 ? void 0 : (ref9 = cartContext.cart) === null || ref9 === void 0 ? void 0 : ref9.contains.prescriptionGlasses;
    const cartContainsSunglasses = cartContext === null || cartContext === void 0 ? void 0 : (ref10 = cartContext.cart) === null || ref10 === void 0 ? void 0 : ref10.contains.sunglasses;
    const cartContainsSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref11 = cartContext.cart) === null || ref11 === void 0 ? void 0 : ref11.contains.subscription;
    const cartContainsContactLensesSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref12 = cartContext.cart) === null || ref12 === void 0 ? void 0 : ref12.contains.contactLensesSubscription;
    const handleChange = React.useCallback((formData)=>{
        (props === null || props === void 0 ? void 0 : props.onChange) && (props === null || props === void 0 ? void 0 : props.onChange(formData));
    }, [
        props
    ]);
    const debouncedHandleChange = React.useMemo(()=>{
        return debounce(200, handleChange);
    }, [
        handleChange
    ]);
    const forms = Object.entries(Slots).reduce((formItem, [key, Slot])=>{
        const formData = (props === null || props === void 0 ? void 0 : props.formInitialData[key]) ? props === null || props === void 0 ? void 0 : props.formInitialData[key] : undefined;
        formItem[key] = /*#__PURE__*/ React.createElement(Form, {
            name: key,
            "data-t": key,
            initialFormState: formData,
            onChange: debouncedHandleChange,
            ref: props === null || props === void 0 ? void 0 : props.formRef,
            onSubmit: props === null || props === void 0 ? void 0 : props.onSubmit,
            className: props === null || props === void 0 ? void 0 : props.className
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "form-content__fields"
        }, /*#__PURE__*/ React.createElement(Slot, {
            cartContainsContactLenses: cartContainsContactLenses,
            cartContainsSolutions: cartContainsSolutions,
            cartContainsSunglasses: cartContainsSunglasses,
            cartContainsSubscription: cartContainsSubscription,
            cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
            cartContainsContactLensesSubscription: cartContainsContactLensesSubscription,
            disableFields: props === null || props === void 0 ? void 0 : props.disableFields
        })), Boolean(props === null || props === void 0 ? void 0 : props.onSubmit) ? /*#__PURE__*/ React.createElement("div", {
            className: "form-content__footer"
        }, /*#__PURE__*/ React.createElement(Divider, {
            className: "form-content__footer-divider"
        }), /*#__PURE__*/ React.createElement(FormGroup, null, /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('common.actions.cancel'),
            "aria-label": getLabel('common.actions.cancel'),
            onClick: props === null || props === void 0 ? void 0 : props.onCancel,
            variant: "outline"
        }), /*#__PURE__*/ React.createElement(Button, {
            type: "submit",
            variant: "solid",
            "aria-label": getLabel('common.actions.save'),
            caption: getLabel('common.actions.save')
        }))) : null));
        return formItem;
    }, {});
    return forms;
};

export { FormSlotsProvider, useBaseFormSlot, useFormSlot, useFormSlotWithoutRedux };
//# sourceMappingURL=form-context.js.map
